import React, { useState } from 'react';

interface TOCProps {
    sections: { title: string }[];
    onSelectSection: (index: number) => void;
}

const CollapsibleTOC: React.FC<TOCProps> = ({ sections, onSelectSection }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors"
            >
                <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                    <span className="font-medium text-gray-900">Table of Contents</span>
                </div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${isOpen ? 'transform rotate-180' : ''}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute left-0 right-0 mt-2 z-20">
                    <div className="bg-white rounded-lg border border-gray-200 shadow-lg py-2 max-h-[60vh] overflow-y-auto">
                        {sections.map((section, index) => (
                            <button
                                key={index}
                                onClick={() => {
                                    onSelectSection(index);
                                    setIsOpen(false);
                                }}
                                className="block text-left w-full px-4 py-2.5 text-sm transition-colors hover:bg-blue-50"
                            >
                                <span className="text-blue-600 font-medium mr-2">{index + 1}.</span>
                                <span className="text-gray-600 hover:text-blue-700">{section.title}</span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CollapsibleTOC;
